import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import Config from "config";
import { map } from "lodash";
import {
  Col,
  Row,
  Card,
  CardBody,
  Nav,
  NavItem,
  NavLink,
  CardTitle,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";
import IdentificationCard from "components/Common/IdentificationCard";
import SectionCard from "components/Common/SectionCard";
import SouscriptionsCard from "components/Common/SouscriptionsCard";
import HmPaginated from "components/Common/hmPaginated";
import SouscriptionsHmListReservation from "components/Common/SouscriptionsHmListReservation";
import RompusHmList from "components/Common/RompusHmList";
import ImpressionsHmListModele from "components/Common/ImpressionsHmListModele";

const backUrl = Config.backOffice.url;
const InvestorDetail = ({
  Titre,
  loading,
  setLoading,
  reservationData,
  dossierData,
  rompusData,
  souscriptionsData,
  activeTab,
  handleAction,
  handleTabClick,
  CustomNavTabs,
  fetchData,
  id,
  ids,
  api,
  signature,
  wait,

  // Function to fetch data
}) => {
  let linkState = { active: "" };

  if (activeTab == "details") {
    linkState.active = "details";
  } else if (activeTab == "contact") {
    linkState.active = "contact";
  } else {
    linkState.active = "details";
  }

  const [modal, setModal] = useState(false);

  const toggleModal = () => setModal(!modal);

  useEffect(() => {
    // Fetch data or any other side effect when component mounts
    fetchData();
  }, [signature]);
  useEffect(() => {
    if (wait === 0) {
      setLoading(false);
      console.log("test finished");
    }
  }, [wait]);
  //   const CustomNavTabs = ({ tabs, activeTab }) => {
  //     const navStyle = {
  //       cursor: "pointer",
  //       borderRadius: "0px",
  //       whiteSpace: "nowrap",
  //     };

  //     return (
  //       <Nav pills className="navtab-bg nav-justified custom-nav-tabs">
  //         {tabs.map((tab, index) => (
  //           <NavItem key={index}>
  //             <NavLink
  //               style={navStyle}
  //               className={`nav-link ${
  //                 activeTab === tab.id ? "active" : ""
  //               }`}
  //               onClick={() => handleTabClick(tab.id)}
  //             >
  //               {tab.label}
  //             </NavLink>
  //           </NavItem>
  //         ))}
  //       </Nav>
  //     );
  //   };
  return (
    <React.Fragment>
      <div className="page-content" style={{ fontFamily: "sans-serif" }}>
        <div className="container-fluid">
          <Row>
            <Col lg="12">
              <Card>
                <CardBody className="border-bottom">
                  <div className="d-flex align-items-center">
                    <h5
                      className="mb-0 card-title flex-grow-1"
                      style={{ fontWeight: "bold", display: "flex" }}
                    >
                      <Link
                        to={`${backUrl}/${api}/`}
                        style={{
                          color: "#3c88c8",
                          textDecoration: "underline !important",
                        }}
                      >
                        {Titre}
                      </Link>{" "}
                      <i className="bx bx-caret-right"></i>{" "}
                      {!loading ? (
                        reservationData.sil
                      ) : (
                        <>
                          <span
                            className="placeholder col-3"
                            style={{ height: "1em" }}
                          ></span>
                        </>
                      )}
                    </h5>
                  </div>

                  <div className="d-flex justify-content-end">
                    <div className="d-flex align-items-end">
                      {reservationData?.can_edit ? (
                        <Link
                          to={`${backUrl}/${api}/${id}/edit`}
                          state={linkState}
                          className="btn btn-sm btn-info"
                        >
                          <i className="bx bx-edit-alt"></i>Modifier
                        </Link>
                      ) : null}
                      &nbsp; &nbsp;
                      {reservationData?.can_destroy ? (
                        <Link to="#!" className="btn btn-sm btn-danger">
                          <i className="bx bx-trash-alt"></i>Supprimer
                        </Link>
                      ) : null}
                    </div>
                  </div>
                </CardBody>
                {CustomNavTabs()}
                <CardBody>
                  {activeTab === "details" && (
                    <div>
                      {!loading ? (
                        <>
                          <Row>
                            <Col sm="6">
                              {reservationData?.detail_reservation
                                ?.Réservation ? (
                                <IdentificationCard
                                  title="Réservation"
                                    ids={reservationData?.detail_reservation?.ids}
                                  details={
                                    reservationData?.detail_reservation
                                      ?.Réservation
                                  }
                                />
                              ) : null}
                            </Col>
                            <Col sm="6">
                              <Row>
                                {reservationData?.detail_reservation?.Cumuls ? (
                                  <SouscriptionsCard
                                    title="Cumuls"
                                    details={
                                      reservationData?.detail_reservation
                                        ?.Cumuls
                                    }
                                  />
                                ) : null}
                              </Row>
                              <Row>
                                {/* <SectionCard
                                title="Documents"
                                details={
                                  reservationData?.detail_reservation
                                    ?.Documents
                                }
                              /> */}
                                {reservationData?.detail_reservation?.Documents
                                  ?.data ? (
                                  <Card>
                                    <CardBody>
                                      <CardTitle className="mb-3">
                                        Documents
                                      </CardTitle>
                                      <div className="table-responsive">
                                        <Table className="table-nowrap align-middle table-hover mb-0">
                                          <tbody>
                                            {map(
                                              reservationData
                                                ?.detail_reservation?.Documents
                                                ?.data,
                                              (file, i) => (
                                                <tr key={"_file_" + i}>
                                                  <td style={{ width: "45px" }}>
                                                    <div className="avatar-sm">
                                                      <span className="avatar-title rounded-circle bg-primary-subtle text-primary font-size-24">
                                                        <i className="bx bxs-file-doc" />
                                                      </span>
                                                    </div>
                                                  </td>
                                                  <td>
                                                    <h5 className="font-size-14 mb-1">
                                                      <a
                                                        href={file.fichier}
                                                        className="text-dark"
                                                        style={{
                                                          whiteSpace: "pretty",
                                                        }}
                                                        download
                                                      >
                                                        {file.titre}
                                                      </a>
                                                    </h5>
                                                    {file?.action?.action ? (
                                                      <button
                                                        className=" btn-sm btn-rounded btn"
                                                        style={{
                                                          backgroundColor:
                                                            "#3C88C8",
                                                          color: "white",
                                                        }}
                                                        onClick={toggleModal}
                                                      >
                                                        {file?.action?.text}{" "}
                                                        {file?.action
                                                          ?.action ? (
                                                          <i className="bx bx-pencil " />
                                                        ) : null}
                                                      </button>
                                                    ) : file?.action?.text ? (
                                                      <>
                                                        {file?.action?.text}{" "}
                                                        {file?.action
                                                          ?.action ? (
                                                          <i className="bx bx-pencil " />
                                                        ) : null}
                                                      </>
                                                    ) : null}
                                                    <p> </p>
                                                  </td>
                                                  <td>
                                                    <div className="text-center">
                                                      {file.fichier && (
                                                        <a
                                                          href={file.fichier}
                                                          className="text-dark"
                                                          download
                                                        >
                                                          <i className="bx bx-download h3 m-0" />
                                                        </a>
                                                      )}
                                                      {file.fichier &&
                                                        file.action && (
                                                          <Modal
                                                            isOpen={modal}
                                                            toggle={toggleModal}
                                                          >
                                                            <ModalHeader
                                                              toggle={
                                                                toggleModal
                                                              }
                                                            >
                                                              Action
                                                            </ModalHeader>
                                                            <ModalBody>
                                                              <p>
                                                                {
                                                                  file.action
                                                                    .confirm
                                                                }
                                                              </p>
                                                            </ModalBody>
                                                            <ModalFooter>
                                                              <Button
                                                                style={{
                                                                  backgroundColor:
                                                                    "#3c88c8",
                                                                }}
                                                                onClick={() => {
                                                                  toggleModal();
                                                                  handleAction(
                                                                    file.action
                                                                  );
                                                                }}
                                                              >
                                                                Valider
                                                              </Button>
                                                              <Button
                                                                color="secondary"
                                                                onClick={
                                                                  toggleModal
                                                                }
                                                              >
                                                                Fermer
                                                              </Button>
                                                            </ModalFooter>
                                                          </Modal>
                                                        )}
                                                    </div>
                                                  </td>
                                                </tr>
                                              )
                                            )}
                                          </tbody>
                                        </Table>
                                      </div>
                                    </CardBody>
                                  </Card>
                                ) : null}
                              </Row>
                              <Col sm="12">
                                <Row>
                                  {reservationData?.detail_reservation?.[
                                    "Dossier de souscription"
                                  ] ? (
                                    <IdentificationCard
                                      title="Dossier de souscription"
                                      details={
                                        reservationData?.detail_reservation?.[
                                          "Dossier de souscription"
                                        ]
                                      }
                                    />
                                  ) : (
                                    ""
                                  )}
                                </Row>
                              </Col>
                            </Col>
                          </Row>

                          <Row>
                            {reservationData?.detail_reservation?.audit ? (
                              <Col sm="12">
                                <SectionCard
                                  title="Audit"
                                  details={
                                    reservationData?.detail_reservation?.audit
                                  }
                                />
                              </Col>
                            ) : null}
                          </Row>
                        </>
                      ) : (
                        <Spinners setLoading={setLoading} />
                      )}
                    </div>
                  )}
                  {/* Dossier SOuscriptions */}
                  {activeTab === "dossier" && (
                    <div className="table-responsive">
                      {!loading ? (
                        <>
                          <ImpressionsHmListModele
                            title={dossierData}
                            data={dossierData.data}
                            header={dossierData.header}
                            itemsPerPage={10}
                          />
                        </>
                      ) : (
                        <Spinners setLoading={setLoading} />
                      )}
                    </div>
                  )}
                  {activeTab === "rompus" && (
                    <div>
                      {!loading ? (
                        <>
                          <RompusHmList
                            title={rompusData}
                            data={rompusData.data}
                            header={rompusData.header}
                            itemsPerPage={10}
                          />
                        </>
                      ) : (
                        <Spinners setLoading={setLoading} />
                      )}
                    </div>
                  )}
                  {activeTab === "souscriptions" && (
                    <div className="table-responsive">
                      {!loading ? (
                        <>
                          <SouscriptionsHmListReservation
                            title={souscriptionsData}
                            data={souscriptionsData.data}
                            header={souscriptionsData.header}
                            itemsPerPage={10}
                          />
                        </>
                      ) : (
                        <Spinners setLoading={setLoading} setWait={wait} />
                      )}
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      <ToastContainer />
    </React.Fragment>
  );
};

export default InvestorDetail;
